import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import intl from "react-intl-universal";

import { TextField } from "components/TextField";

import { FIELD_PLAYERS } from "./constants";
import { IInvitePlayerDialogProps } from "./types";

export const InvitePlayerDialog = ({
  onNewPlayerAdded,
  hideDialog,
}: IInvitePlayerDialogProps) => {
  const handleClose = () => {
    hideDialog();
  };
  const handleCancel = () => {
    hideDialog();
  };

  const handleSubmit = (values: any) => {
    const players = values[FIELD_PLAYERS];
    onNewPlayerAdded(players);
  };

  return (
    <Dialog open onClose={handleClose}>
      <Formik
        enableReinitialize
        initialValues={{ [FIELD_PLAYERS]: [] }}
        onSubmit={handleSubmit}
        validationSchema={Yup.object().shape({
          [FIELD_PLAYERS]: Yup.string().required(
            intl.get("FORM_VALIDATION_REQUIRED")
          ),
        })}
      >
        {() => {
          return (
            <Form>
              <DialogTitle>{intl.get("TEAM_EDIT_ADD_PLAYER")}</DialogTitle>
              <DialogContent>
                <Grid container>
                  <Grid item xs={12}>
                    <Typography gutterBottom>
                      <strong>{intl.get("TEAM_EDIT_PLAYERS")}</strong>
                    </Typography>
                    <Typography gutterBottom variant="caption">
                      {`(${intl.get("TEAM_EDIT_PLAYERS_TIPS")})`}
                    </Typography>
                    <Field
                      multiline
                      rows="4"
                      component={TextField}
                      name={FIELD_PLAYERS}
                    />
                    <Box mt={2} />
                  </Grid>
                </Grid>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCancel}>
                  {intl.get("TEAM_EDIT_BUTTON_ADD_PLAYER_CANCEL")}
                </Button>
                <Button color="secondary" type="submit" variant="contained">
                  {intl.get("TEAM_EDIT_BUTTON_ADD_PLAYER")}
                </Button>
              </DialogActions>
            </Form>
          );
        }}
      </Formik>
    </Dialog>
  );
};
